import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Card({ as, children, className, variant, ...rest }) {
    const Component = as ?? "div";
    return (_jsx(Component, { className: classNames("cvr-card", { "cvr-card--elevated": variant === "elevated" }, className), ...rest, children: children }));
}
